import FileVO, {FileType} from "../../../../../ts/common/FileVO";
import {constructFormData, FormDataVO} from "../../../../../ts/manager/FileManager";
import ImageVO from "../../../../../ts/common/ImageVO";
import FormSubmitVO from "./FormSubmitVO";
import {IAnyObject} from "../../../../../ts/common/SimpleInterface";

export default class FileReplaceVO extends FormSubmitVO
{
    fileType: FileType = "file";
    savedFileVOs: FileVO[] = [];
    formDataVOs: FormDataVO[] = [];
    deleteFileIDs: number[] = [];

    constructor(savedFileVOs: FileVO[]|null = null)
    {
        super();
        this.savedFileVOs = savedFileVOs ?? [];
    }

    clone(to?:FileReplaceVO):FileReplaceVO
    {
        to = to ?? new FileReplaceVO();
        to.fileType = this.fileType;
        to.savedFileVOs = this.savedFileVOs.slice();
        to.formDataVOs = this.formDataVOs.slice();
        to.deleteFileIDs = this.deleteFileIDs.slice();
        return to;
    }

    fileCount(): number
    {
        let count = 0;
        for(let fileVO of this.savedFileVOs)
        {
            if (!this.deleteFileIDs.includes(fileVO.id))
            {
                count ++;
            }
        }
        return count + this.formDataVOs.length;
    }

    isEmpty(): boolean
    {
        return !this.fileCount();
    }


    getSubmitValue(): number[]
    {
        const fileIDs:number[] = [];
        for(let fileVO of this.savedFileVOs){
            fileIDs.push(fileVO.id);
        }
        return fileIDs;
    }

    constructFormData(itemID:string):FormData
    {
        const formData =  constructFormData(this.formDataVOs);
        const jsonParams:IAnyObject = {}
        jsonParams.item_id = itemID;
        formData.append("json_params", JSON.stringify(jsonParams));
        return formData;
    }

}

export class ImageFileReplaceVO extends FileReplaceVO
{
    fileType: FileType = "image";
    savedFileVOs: ImageVO[] = [];

    constructor(savedFileVOs: ImageVO[] = [], itemID: string|null = null)
    {
        super(savedFileVOs);
        this.savedFileVOs = savedFileVOs ?? [];
    }

    clone(to?:ImageFileReplaceVO):ImageFileReplaceVO
    {
        to = to ?? new ImageFileReplaceVO();
        return super.clone(to) as ImageFileReplaceVO;
    }
}